<template>
  <!-- eslint-disable vue/attribute-hyphenation -->
  <div id="app">
    <v-app>
      <v-flex fluid class="fill-height pa-0" :class="this.$route.params.action === 'customerOnboarding' ? 'mobile-views' : ''">
        <v-overlay
          v-if="loaderEnabled || screenLoaded"
          :opacity="0.5"
          z-index="225"
        >
          <v-card elevation="10"
            width="444" height="220"
            color="white"
            style="border-radius:11px"
          >
            <div class="text-center pt-15">
              <v-progress-circular
                size="50"
                :width="5"
                indeterminate
                class="circular-loader mb-5"
                :color="customCSS['screenLoader-color'] || customCSS['primary']"
              /><br/>
              <span class="pl-3 text-h5 black--text font-weight-black">
                {{ $t('loading') }}
              </span>
            </div>
          </v-card>
        </v-overlay>
        <!-- logged in header part -->
        <div class="header-app-bar">
          <v-content style="padding-top: 0px">
              <router-view />
          </v-content>
        </div>
      </v-flex>
    </v-app>
    <toast :config="alertMessage" v-if="alertMessage && alertMessage.component!=='alert'"/>
    <IdleTimeout v-if="this.$route.params.applicationName === 'fede' && this.$route.params.productType !== undefined && this.$route.params.action !== 'customerOnboarding' && this.$route.params.action !== 'productInfo'" />
  </div>
</template>

<script>
import toastMixin from './_core/mixins/toastMixin';
import authMixin from './_core/mixins/authMixin';
import store from '@/store';
import appConfiguration from '@/plugins/appSettings';
import * as colors from '@/_core/util/themeUtility';
import appCommonMixin from './_core/mixins/appCommonMixin';
import config from '../server/config/config.json';
import IdleTimeout from './components/IdleTimeout.vue';
// import Header from '../src/components/Header.vue';

export default {
  name: 'App',
  mixins: [toastMixin, authMixin, appCommonMixin],
  created() {
    this.customCSS = colors.colors;
    document.title = this.$t('applicationName');
    this.noAuthRequired = store.getters['userStore/userData'].isRefreshToken || false;
    this.$vuetify.theme.themes.light.primary = this.customCSS.primary ?? '';
    this.$vuetify.theme.themes.light.secondary = this.customCSS.secondary ?? '';
    // Below method is called to fetch the value from Custom CSS & pass onto SCSS style for background color of mobile view for the landing page
    this.setBackgroundColor();
  },
  data() {
    return {
      noAuthRequired: false,
      accessToken: null,
      fecaProps: null,
      customCSS: {},
      gliaScript: null,
    };
  },
  provide() {
    const authInfo = {};
    const appInfo = {};
    const fecaProps = {};
    const configurations = {};
    const displaySnackBar = {};
    const screenLoader = {};

    Object.defineProperty(authInfo, 'token', {
      enumerable: true,
      get: () => this.accessToken,
    });
    Object.defineProperty(appInfo, 'appSettings', {
      enumerable: true,
      get: () => appConfiguration,
    });
    Object.defineProperty(fecaProps, 'fecaProp', {
      enumerable: true,
      get: () => this.fecaProps,
    });
    Object.defineProperty(configurations, 'configurations', {
      enumerable: true,
      get: () => config,
    });
    Object.defineProperty(displaySnackBar, 'displaySnackBar', {
      enumerable: true,
      get: () => this.displaySnackBar,
    });
    Object.defineProperty(screenLoader, 'screenLoader', {
      enumerable: true,
      get: () => this.updateScreenLoader,
    });
    return {
      authInfo,
      appInfo,
      fecaProps,
      configurations,
      displaySnackBar,
      screenLoader,
    };
  },
  components: {
    IdleTimeout,
    toast: () => import('@/components/ErrorHandler/ErrorHandler.vue'),
  },
  methods: {
    updateScreenLoader(value) {
      this.screenLoaded = value;
    },
    loadGliaScript() {
      this.gliaScript = document.createElement('script');
      this.gliaScript.async = true;
      this.gliaScript.src = this.$appSettings.dcoConfigurations.gliaScript;
      this.gliaScript.id = 'glia';
      document.head.appendChild(this.gliaScript);
    },
    setBackgroundColor() {
      document.documentElement.style.setProperty('--backgroundColor', this.customCSS['mobileView-backgroundColor']);
      document.documentElement.style.setProperty('--formTitle-fontFamily', this.customCSS['formTitle-fontFamily']);
      document.documentElement.style.setProperty('--formSubtitle-fontFamily', this.customCSS['formSubtitle-fontFamily']);
      document.documentElement.style.setProperty('--onboarding-sectionContentColor', this.customCSS['onboarding-sectionContentColor']);
      document.documentElement.style.setProperty('--onboarding-sectionSubTitleColor', this.customCSS['onboarding-sectionSubTitleColor']);
      document.documentElement.style.setProperty('--onboarding-sectionHelperTextColor', this.customCSS['onboarding-sectionHelperTextColor']);
      document.documentElement.style.setProperty('--formContent-filled-components-backgroundColor', this.customCSS['formContent-filled-components-backgroundColor']);
      document.documentElement.style.setProperty('--secondaryColor', this.customCSS.secondary);
    },
  },
  watch: {
    '$route'(to, from) {
      if (this.$appSettings.dcoConfigurations.routes.includes(to.params.action)) {
        this.loadGliaScript();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$importedBgColor: var(--backgroundColor);
.hide-nav::-webkit-scrollbar {
  display: none;
}
@media only screen and (min-width: 320px) and (max-width: 960px) {
.mobile-views {
  background: $importedBgColor !important;
}
}

</style>
